import React from 'react';

const SectionView = ({ number, title, children }) => {
    return (
        <div>
            <h2>{`${number}. ${title}`}</h2>
            {children}
        </div>
    );
};

export default SectionView;
